import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import CreateCredit from '@/plugins/graphql/mutations/v2/credit-create.gql';
import CreditsList from '@/plugins/graphql/queries/v2/grab-express-topup-list.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import NumericInput from '@/components/v2/NumericInput.vue';
import Uploader from '@/components/v2/Uploader';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import CreditWidget from '@/components/v2/CreditWidget';
import AppBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { CreditPaymentType } from '@/helpers/entities/enums/v2/CreditPaymentType';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import { CG_API_BASE } from '@/helpers/constants/app';
import GcashCheckoutCreate from '@/components/v2/ecommerce/GcashCheckoutCreate';
import BilleaseCheckoutCreate from '@/components/v2/ecommerce/BilleaseCheckoutCreate';
let CreditForm = class CreditForm extends Mixins(RouterParamsAppMixin, AlertMixin, ButtonLoaderMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            appUuid: '',
            processingFee: 0.0,
            total: 0.0,
            amount: 0.0,
            paymentType: 'bank',
            depositSlips: [],
            extensionKey: '',
            key: '',
        };
    }
    get gcashCallbackUrl() {
        return `${CG_API_BASE}/gcash/callback?uuid=${this.appUUID}&channel=topup&key=${this.uuid}`;
    }
    get billeaseCallbackUrl() {
        return `${CG_API_BASE}/billease/status_update?uuid=${this.appUUID}&channel=topup&key=${this.uuid}`;
    }
    get currentPath() {
        return window.location.href;
    }
    get paymentMethods() {
        return [
            {
                text: 'Bank Deposit',
                value: 'bank',
                rate: 0.0,
            },
            {
                text: 'GCash',
                value: 'gcash',
                rate: 0.025,
            },
            {
                text: 'BillEase',
                value: 'billease',
                rate: 0.015
            },
        ];
    }
    paymentHeight(payment) {
        if (payment === CreditPaymentType.Bank) {
            return '28';
        }
        if (payment === CreditPaymentType.GCash) {
            return '28';
        }
        if (payment === CreditPaymentType.BillEase) {
            return '60';
        }
        /*
         * Temporary Disable for future Implementation
        if (payment === CreditPaymentType.BPI) {
          return '28';
        }
         */
    }
    paymentWidth(payment) {
        if (payment === CreditPaymentType.Bank) {
            return '39';
        }
        if (payment === CreditPaymentType.GCash) {
            return '28';
        }
        if (payment === CreditPaymentType.BillEase) {
            return '60';
        }
        /*
         * Temporary Disable for future Implementation
         if (payment === CreditPaymentType.BPI) {
           return '66';
         }
         */
    }
    setPaymentType(payment) {
        this.form.paymentType = payment;
    }
    get validAmount() {
        return this.form.amount >= 1000;
    }
    computeTotal(amount, rate, type) {
        if (type === CreditPaymentType.GCash) {
            const processingFee = amount * 0.025;
            this.form.processingFee = processingFee;
            this.form.total = parseFloat(amount) + processingFee;
        }
        else if (type === CreditPaymentType.BillEase) {
            const processingFee = amount * 0.015;
            this.form.processingFee = processingFee;
            this.form.total = parseFloat(amount) + processingFee;
        }
        else {
            this.form.processingFee = rate;
            this.form.total = parseFloat(amount) + rate;
        }
    }
    paymentImage(payment) {
        if (payment === 'bank') {
            return require('@/assets/images/bank-black.png');
        }
        /*
        * Temporary Disable for future Implementation
        if (payment === 'bpi') {
          return require('@/assets/images/bpi.png');
        }
        */
        if (payment === 'gcash') {
            return require('@/assets/images/gcash.png');
        }
        if (payment === 'billease') {
            return require('@/assets/images/billease.png');
        }
    }
    get bpiImageUrl() {
        return require('@/assets/images/bpi.png');
    }
    get sbImageUrl() {
        return require('@/assets/images/security-bank.png');
    }
    get disablePayButton() {
        if (this.form) {
            return ((this.form.paymentType === CreditPaymentType.Bank && this.form.depositSlips.length === 0) ||
                !this.validAmount ||
                this.form.paymentType === '');
        }
        return false;
    }
    async onSubmit(form) {
        this.requestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = 'Top-up was successfully submitted!';
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.formResetter(form);
            this.requestDone();
        });
    }
    formResetter(form) {
        const self = this;
        form.processingFee = 0.0;
        form.total = 0.0;
        form.amount = 0.0;
        form.paymentType = 'bank';
        form.appUuid = '';
        self.$refs.uploader.clearFiles();
        form.depositSlips = [];
        form.extensionKey = '';
        form.key = '';
    }
    async create(form) {
        const appUuid = this.appUUID;
        const keyData = this.uuid.split(':');
        const key = keyData[0];
        const extensionKey = keyData[1];
        const { processingFee, total, amount, paymentType } = form;
        const inputImages = this.form.depositSlips.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: CreateCredit,
            variables: {
                input: {
                    appUuid,
                    key,
                    extensionKey,
                    processingFee,
                    total,
                    amount,
                    paymentType,
                    depositSlips: inputImages,
                },
            },
            refetchQueries: [
                {
                    query: CreditsList,
                    variables: {
                        appUuid,
                    },
                },
                {
                    query: AppBasic,
                    variables: {
                        appUuid,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], CreditForm.prototype, "uuid", void 0);
CreditForm = __decorate([
    Component({
        components: {
            NumericInput,
            ActionButton,
            Uploader,
            BaseImagePlaceholder,
            CreditWidget,
            ViewportSizeMixin,
            GcashCheckoutCreate,
            BilleaseCheckoutCreate,
        },
    })
], CreditForm);
export default CreditForm;
